import { useState } from "react";
import { NavLink , Link } from "react-router-dom";
import '../styles/Navbar.css';


function Navbar() {

    const [menuOpen , setMenuOpen] = useState(false)

  return (
    <nav>
      <Link to="/home">
        <img src="acm_logo.jpeg" alt="acm_logo" className="acm_logo" />
      </Link>

      <div className="menu" onClick={() => {
        setMenuOpen(!menuOpen)
      }}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <ul className={menuOpen ? 'open' : ''}>
        <li>
          <NavLink to="/home">Home</NavLink>
        </li>
        <li>
          <NavLink to="https://forms.gle/dbm2BiLQxEa6mGfx7">Register</NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
